// deps - BetterAjax, Utility,

var PwnageProductFormSimple = {
  data: {},
  init: function () {
    this.data.mainEl = document.querySelector("[data-product]")
    this.data.flags = {
      colorpicker: this.data.mainEl.dataset.colorpicker != null,
      slider: this.data.mainEl.dataset.slider, // null | single | multiple
    }
    this.data.productSelectEl = document.getElementById("productSelect")
    this.data.productOptionsEl =
      this.data.productSelectEl.querySelectorAll("option")
    this.data.priceEl = document.getElementById("product-price--dynamic")
    this.data.priceCompareAtEl = document.getElementById(
      "product-price-compare--dynamic"
    )
    this.data.backorderTextEl = document.getElementById("backorderText")
    this.data.swiperEl = PwnageFormUtility.SliderManager.data.swiperEl
    this.data.swiperSlidesEls =
      PwnageFormUtility.SliderManager.data.swiperSlidesEls
    this.data.submitBtnEl = document.getElementById("AddToCart")
    this.data.quantityEl = document.getElementById("Quantity")
    this.data.checkoutBtnEl = document.getElementById(
      "button__checkout-dynamic"
    )

    this.onChange = null
  },

  bindUIActions: function () {
    // select change swiper
    if (this.data.productSelectEl) {
      this.data.productSelectEl.addEventListener("change", () => {
        this.updateUI()
        this.updateSlider()
        if (this.onChange) this.onChange(this.getSelectedElement().dataset)
      })
    }

    this.data.submitBtnEl.addEventListener("click", (event) => {
      event.preventDefault()
      const productsForPurchase = this.getUniqueProducts()
      new BetterAJAX(
        productsForPurchase.map((p) => p.image),
        productsForPurchase.map((p) => p.variantId),
        productsForPurchase.map((x) => this.data.quantityEl.value || 1),
        () => {
          if (this.data.checkoutBtnEl) this.data.checkoutBtnEl.disabled = false
        }
      )
    })
  },

  initUI: function () {
    if (PwnageFormUtility.URLManager.params) {
      this.data.productSelectEl.value =
        PwnageFormUtility.URLManager.params.variant
      if (
        this.data.productSelectEl.value !=
        PwnageFormUtility.URLManager.params.variant
      ) {
        this.data.productSelectEl.value = this.data.productOptionsEl[0].value
      }
    }
    this.updateUI()
  },

  updateUI: function () {
    if (this.data.backorderTextEl) {
      if (this.getSelectedOption().inInventory == "true")
        this.data.backorderTextEl.classList.add("hide")
      else this.data.backorderTextEl.classList.remove("hide")
    }

    if (
      this.data.submitBtnEl &&
      this.getSelectedElement().dataset.available === "false"
    ) {
      this.data.submitBtnEl.disabled = true
    } else {
      this.data.submitBtnEl.disabled = false
    }

    PwnageFormUtility.PriceManager.calculate()
    PwnageFormUtility.URLManager.updateURL()
  },

  updateSlider: function () {
    if (this.data.swiperSlidesEls) {
      if (!PwnageFormUtility.SliderManager.data.disableInitial) {
        if (PwnageFormUtility.SliderManager.data.sliderType == "multiple") {
          PwnageFormUtility.SliderManager.setSelectedVariantById(
            this.getSelectedOption().variantId
          )
        }
        if (PwnageFormUtility.SliderManager.data.sliderType == "single") {
          PwnageFormUtility.SliderManager.setSelectedSlideById(
            this.getSelectedOption().variantId
          )
        }

        for (let i = 0; i < this.data.swiperSlidesEls.length; i++) {
          if (
            this.data.swiperSlidesEls[i].dataset.variant ==
            this.data.productSelectEl.value
          ) {
            PwnageFormUtility.SliderManager.data.swiperSlider.slideTo(i)
            break
          }
        }
      }
    }
  },

  getUniqueProducts: function () {
    return [this.getSelectedOption()]
  },

  getParams: function () {
    if (this.getSelectedIndex() == 0) return null
    return [["variant", this.getSelectedOption().variantId].join("=")]
  },

  getSelectedOption() {
    const el = this.getSelectedElement()
    return {
      variantId: el.value,
      price: el.dataset.price,
      compareAtPrice: el.dataset.compareAtPrice,
      image: el.dataset.image,
      inInventory: el.dataset.inInventory,
    }
  },
  getSelectedElement() {
    return this.data.productOptionsEl[this.getSelectedIndex()]
  },
  getSelectedIndex() {
    return this.data.productSelectEl.selectedIndex
  },
}
